/* eslint-disable no-await-in-loop */
export class TimeoutExceededError extends Error {
  constructor(message) {
    super(message);
    this.name = 'TimeoutExceededError';
  }
}

// eslint-disable-next-line no-promise-executor-return
export const sleep = ms => new Promise(res => setTimeout(res, ms));

export const retryWhileNotTrue = (callback, times, ms) => {
  let i = 0;
  return async (...args) => {
    let result = await callback(...args);
    if (result) return result;
    while (i < times) {
      await sleep(ms);
      result = await callback(...args);
      if (result) return result;
      i += 1;
    }
    throw new TimeoutExceededError(`Timeout limit was exceeded: after ${times} retries every ${ms} ms`);
  };
};

export const retry = (callback, times) => {
  let i = 1;
  return async (...args) => {
    while (i <= times) {
      try {
        return await callback(...args);
      } catch (e) {
        i += 1;
        if (i <= times) {
          await sleep(500 * i);
        } else {
          throw e;
        }
      }
    }
    throw new TimeoutExceededError();
  };
};
